import { defineComponent as b, inject as k, computed as f, h as d } from "vue";
import { dataTableInjectionKey as w } from "./ghl-ui.es975.js";
import y from "./ghl-ui.es293.js";
import D from "./ghl-ui.es894.js";
import S from "./ghl-ui.es1425.js";
const p = "_n_all__", m = "_n_none__";
function x(e, t, n, o) {
  return e ? (l) => {
    for (const r of e)
      switch (l) {
        case p:
          n(!0);
          return;
        case m:
          o(!0);
          return;
        default:
          if (typeof r == "object" && r.key === l) {
            r.onSelect(t.value);
            return;
          }
      }
  } : () => {
  };
}
function P(e, t) {
  return e ? e.map((n) => {
    switch (n) {
      case "all":
        return {
          label: t.checkTableAll,
          key: p
        };
      case "none":
        return {
          label: t.uncheckTableAll,
          key: m
        };
      default:
        return n;
    }
  }) : [];
}
const C = b({
  name: "DataTableSelectionMenu",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const {
      props: t,
      localeRef: n,
      checkOptionsRef: o,
      rawPaginatedDataRef: l,
      doCheckAll: r,
      doUncheckAll: v
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = k(w), h = f(() => x(o.value, l, r, v)), _ = f(() => P(o.value, n.value));
    return () => {
      var a, c, u, i;
      const { clsPrefix: s } = e;
      return d(y, { theme: (c = (a = t.theme) === null || a === void 0 ? void 0 : a.peers) === null || c === void 0 ? void 0 : c.Dropdown, themeOverrides: (i = (u = t.themeOverrides) === null || u === void 0 ? void 0 : u.peers) === null || i === void 0 ? void 0 : i.Dropdown, options: _.value, onSelect: h.value }, {
        default: () => d(D, { clsPrefix: s, class: `${s}-data-table-check-extra` }, {
          default: () => d(S, null)
        })
      });
    };
  }
});
export {
  C as default
};
